// extracted by mini-css-extract-plugin
export default {"input":"AddAttachmentMenuItem-module__input--ZVV1H"};